const getRatio = (ratio = '1/1') => {
  return {
    '1/1': '100%',
    '16/9': 'calc(100% / 16 * 9)',
    '21/9': 'calc(100% / 21 * 9)',
    '3/4': 'calc(100% / 3 * 4)',
    '4/3': 'calc(100% / 4 * 3)',
    '4/6': 'calc(100% / 4 * 6)',
    '6/4': 'calc(100% / 6 * 4)',
    '9/16': 'calc(100% / 9 * 16)',
    '9/21': 'calc(100% / 9 * 21)',
  }[ratio];
};

export default getRatio;
